import axios from 'axios'
import {  getUserData } from '@utils'

export const apiCallFetch = async (url, options) => {
  try {
    const response = await fetch(url, options)
    const res = await response.json()

    if (res.error) throw res.error
    if (!response.ok) throw response

    return {
      ok: true,
      res
    }
  } catch (error) {
    return {
      ok: false,
      error
    }
  }
}

export const apiCall = async (options) => {
  try {
    const response = await axios(options)
    return {
      ok: true,
      res: response.data
    }
  } catch (error) {
    return {
      ok: false,
      res: error?.response?.data?.error?.description ?? error,
      extra: error?.response?.data?.error?.extra ?? null
    }
  }
}

export const noAuthGet = ({ url }) => {
  const options = {
    url,
    method: 'GET'
  }
  return apiCall(options)
}
export const noAuthPost = async ({ url, body }) => {
  const options = {
    method: 'POST',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: body
  }
  return apiCall(options)
}

export const noAuthPostFetch = async ({ url, body }) => {
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  }
  return apiCallFetch(url, options)
}

export const authGet = async ({ url, params }) => {
  const { token } = getUserData()
  const options = {
    url,
    method: 'GET',
    headers: {
      // 'x-access-token':
      //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfZG9jIjp7Il9pZCI6IjYyNGRhYTI5ZmY1ZDJmMDAxNjMyYTZiMyIsInVzZXJuYW1lIjoicGQtcGFibG8iLCJlbWFpbCI6InBhYmxvLml6cXVpZXJkb0BwYWdvZGlyZWN0by5jb20iLCJyb2xlIjoiNjIwMGE0OWY3ZjUwMDkyNDMwYmQ5NmZiIiwiY29tbWVyY2VfYXNzb2NpYXRlZCI6IjYwNzExZGQ4OGEwZjNlMDAxNTI5ZDcxOSIsInNlc3Npb24iOiIwMDAwMDAiLCJzdGF0dXMiOiJhY3RpdmUifSwiaWF0IjoxNjY5ODY4OTY3LCJleHAiOjE2Njk4NzI1Njd9.Ex9IcKwmKRrKSFFZmWEgt2HmCUm0DvJ8vEzvi7ojcpg',
      'x-access-token': token,
      'Access-Control-Allow-Origin': '*'
    }
  }
  if (params) {
    options.params = params
  }
  return apiCall(options)
}
export const authPost = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    data: body
  }

  return apiCall(options)
}

export const authPostTemp = async ({ url, body }) => {
  const { token } = getUserData()

  const options = {
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // TODO: return value to token
      'x-access-token': token
    },
    data: body
  }

  return apiCall(options)
}

export const authPostTemp2 = async ({ url, body }) => {
  const { token } = getUserData()

  const options = {
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    data: body
  }

  return apiCall(options)
}

export const authDelete = async ({ url, body }) => {
  const { token } = getUserData()

  const options = {
    url,
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    }
  }

  return apiCall(options)
}

export const authPut = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    url,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    data: body
  }

  return apiCall(options)
}

export const authPostUser = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'x-access-token': token
    },
    data: body
  }

  const t = await axios(options)
}

export const authPatch = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    url,
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    data: body
  }

  return apiCall(options)
}

export const authPostFetch = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(body)
  }

  return apiCallFetch(url, options)
}

export const authPatchFetch = async ({ url, body }) => {
  const { token } = getUserData()
  const options = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(body)
  }

  return apiCallFetch(url, options)
}
export const authGetFetch = async (url) => {
  const { token } = getUserData()
  const options = {
    method: 'GET',
    headers: {
      'x-access-token': token
    }
  }

  return apiCallFetch(url, options)
}

export const authPostFetchFormData = async ({ url, formData }) => {
  const { token } = getUserData()
  const options = {
    method: 'POST',
    headers: {
      'x-access-token': token
    },
    body: formData
  }

  return apiCallFetch(url, options)
}
